
import Vue from 'vue'
import BusinessHours from '../business-hours/index.vue'

export default Vue.extend({
  name: 'PointCard',
  components: {
    BusinessHours
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    hours: {
      type: String,
      required: true,
      default: ''
    },
    useMerge: {
      type: Boolean,
      required: true,
      default: false
    },
    cardTypes: {
      type: String,
      required: true,
      default: ''
    },
    address: {
      type: String,
      required: true,
      default: ''
    },
    disabilitySupport: {
      type: Boolean,
      required: true,
      default: false
    },
    linkData: {
      type: Object,
      default: () => ({})
    },
    hideButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    parseCardTypes () {
      return this.cardTypes?.split(',')?.map((type, idx, arr) => type + (idx === arr?.length - 1 ? '' : ','))
    }
  }
})
